export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fb04769bc173f9b01ffd3b23099bf019333873a94&name=fetchTypeahead!'